import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerRoutingModule } from './partner-routing.module';
import { ReservationComponent } from './partner/reservation/reservation.component';
import { ReleaseComponent } from './partner/release/release.component';
import { EventComponent } from './partner/event/event.component';
import { AddComponent } from './partner/event/add/add.component';
import { AddPartnerOverviewComponent } from './partner/event/add-overview/add-overview.component';
import { AppMaterialModule } from 'src/app/helpers/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from 'src/app/pipes/shared-pipes.module';
;
import { SharedComponentsModule } from '../shared-components.module';
import { TruncateModule } from 'src/app/pipes/truncate.module';
import { TranslateStateModule } from 'src/app/pipes/translate-state.module';
import { TranslateFilterModule } from 'src/app/pipes/translate-filter.module';
import { MandantModule } from './admin/mandant/mandant.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ReportComponent } from './partner/report/report.component';
import { ChartsModule } from '@carbon/charts-angular';
import { RouterModule } from '@angular/router';
/***
 * The options for the WYSISYG Editor
 */
const toolbarOptions = [
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  [{ 'align': [] }]
];

@NgModule({
  declarations: [
    ReservationComponent,
    ReleaseComponent,
    EventComponent,
    AddPartnerOverviewComponent,
    AddComponent,
    ReportComponent
  ],
  imports: [
    CommonModule,
    PartnerRoutingModule,
    AppMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    SharedPipesModule,
    SharedComponentsModule,
    TruncateModule,
    TranslateStateModule,
    TranslateFilterModule,
    MandantModule,
    NgxDropzoneModule,
    SharedPipesModule,
    ChartsModule,
    RouterModule
  ]
})
export class ParterModule { }
